import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-handler-error',
  templateUrl: './handler-error.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true
})
export class HandlerErrorComponent implements OnInit {

  statusText?: string;
  message?: string;
  status?: string;

  constructor(private _activateRoute: ActivatedRoute,
  ) { }

  ngOnInit() {

    this._activateRoute.paramMap.subscribe(p => {
      this.statusText = p.get('statusText') || undefined;
      this.status = p.get('status') || undefined;
      this.message = p.get('message') || undefined;
    });
  }
}
